import Privacy from '@components/privacyPolicy/privacy';
import styles from '@styles/privacyPolicy/privacy.module.scss';
import SeoMeta from '@components/common/seo';

function PrivacyPage() {
	return (
		<>
			<SeoMeta />
			<Privacy styles={styles} />
		</>
	);
}

PrivacyPage.Layout = true;
export default PrivacyPage;
